@if (value === budgetValues.Cheap) {
  <span class="font-roboto text-sm text-neutral-600">
    <span> {{ currency === 'EUR' ? '€' : '$' }}</span>
  </span>
}
@if (value === budgetValues.Moderate) {
  <span class="font-roboto text-sm text-neutral-600">
    <span> {{ currency === 'EUR' ? '€€' : '$$' }}</span>
  </span>
}
@if (value === budgetValues.Expensive) {
  <span class="font-roboto text-sm text-neutral-600">
    <span> {{ currency === 'EUR' ? '€€€' : '$$$' }}</span>
  </span>
}
